const { REACT_APP_INITIAL_PAUSE_START, REACT_APP_INITIAL_PAUSE_END, REACT_APP_API_HOST, REACT_APP_MAX_DELTA, REACT_APP_TIME_STOPPED } = process.env;

export default ({
    InitialPauseStart: REACT_APP_INITIAL_PAUSE_START ?? '00:00',
    InitialPauseEnd: REACT_APP_INITIAL_PAUSE_END ?? '08:30',
    Host: REACT_APP_API_HOST ?? 'http://localhost:5050',
    MaxDelta: REACT_APP_MAX_DELTA ?? 300,
    TimeStopped: REACT_APP_TIME_STOPPED ?? 0
});